import { IconBookmark, IconBuildings, IconInfo, IconPencil, IconShare, IconTools } from '@assets/images/icon';
import { IconFacetime, IconTopology } from '@assets/images/main';
import { cameraEdge, camreaServer } from '@assets/images/main/camera';
import { IconCctvOff } from '@assets/images/main/icon';

export default {
  a: [
    { text: 'Ra vào bằng thiết bị di động Sản phẩm', icon: IconInfo },
    { text: 'Cấu trúc xử lý', icon: IconTopology },
    { text: 'Phương thức thu thập hình ảnh', icon: IconFacetime },
    { text: 'Số lượng camera hỗ trợ', icon: IconCctvOff },
    { text: 'Phương thức lắp đặt', icon: IconTools },
    { text: 'Không gian ứng dụng', icon: IconBuildings },
    { text: 'Môi trường đề xuất', icon: IconBookmark },
    { text: 'Điểm nổi bật', icon: IconPencil },
    { text: 'Kết nối bên ngoài', icon: IconShare },
  ],

  b: [
    { text: 'Tích hợp phân tích AI + ORBRO OS trên một thiết bị duy nhất' },
    { text: 'Vận hành độc lập bằng thiết bị Edge (bao gồm ORBRO OS)' },
    { text: 'Thu thập hình ảnh qua mạng như RTSP / ONVIF' },
    { text: 'Tối đa 2 thiết bị' },
    { text: 'Lắp đặt dễ dàng chỉ với nguồn điện và kết nối camera' },
    { text: 'Cửa ra vào, không gian nội thất nhỏ hẹp, các cơ sở kinh doanh quy mô nhỏ ' },
    { text: 'Các địa điểm cần lắp đặt nhanh chóng với chức năng cơ bản mà không cần Server' },
    { text: 'Có thể lắp đặt và vận hành chỉ với một thiết bị, chi phí thấp' },
    { text: 'Cung cấp một phần API (hỗ trợ kết nối cơ bản)' },
  ],

  c: [
    { text: 'Hệ thống xử lý hình ảnh AI hiệu suất cao dựa trên Server' },
    { text: 'Liên kết AI Server + ORBRO Server' },
    { text: 'Thu thập hình ảnh qua mạng như RTSP / ONVIF' },
    { text: 'Từ 6 thiết bị trở lên (có thể mở rộng bằng Server)' },
    { text: 'Cấu hình dựa trên mạng, tập trung tại phòng Server/phòng điều khiển' },
    { text: 'Bệnh viện lớn, trung tâm logistics, cơ quan công cộng và các môi trường giám sát tích hợp khác' },
    { text: 'Khi cần phân tích video đa kênh ở các cơ sở quy mô vừa và lớn' },
    { text: 'Tích hợp hoàn toàn với các tính năng nâng cao của ORBRO OS như SOP, Heatmap, Zone' },
    { text: 'Cung cấp API đầy đủ (kết nối thời gian thực với sự kiện, vị trí, tình huống)' },
  ],

  spec: [
    {},

    {
      image: cameraEdge,
      link: '/vi/camera/edge',
      title: 'ORBRO Edge AI',
      desc: '',
    },

    {
      image: camreaServer,
      link: '/vi/camera/server',
      title: 'ORBRO AI Server',
      desc: '',
    },
  ],
};
